import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'dk-sayfa-bulunamadi',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sayfa-bulunamadi.component.html',
  styleUrls: ['./sayfa-bulunamadi.component.scss'],
})
export class SayfaBulunamadiComponent {
  @Input() isShow = true;
}
